import React from "react";
import "./PageHero.scss";

const PageHero = ({ title, bgImage }) => {
  return (
    <section
      className="page-hero"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="page-hero__overlay">
        <h1>{title}</h1>
      </div>
    </section>
  );
};

export default PageHero;
